import React from 'react';

import type { FC } from 'react';

export const Replay: FC<React.SVGAttributes<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path d="M7.97473 3.76076V1.90076C7.97473 1.60076 7.61473 1.4541 7.40806 1.66743L4.87473 4.1941C4.7414 4.32743 4.7414 4.5341 4.87473 4.66743L7.4014 7.1941C7.61473 7.40076 7.97473 7.2541 7.97473 6.9541V5.0941C10.4614 5.0941 12.4281 7.3741 11.8814 9.9541C11.5681 11.4674 10.3414 12.6874 8.83473 13.0008C6.45473 13.5008 4.33473 11.8674 4.01473 9.66076C3.96806 9.34076 3.68806 9.0941 3.3614 9.0941C2.9614 9.0941 2.6414 9.44743 2.69473 9.84743C3.10806 12.7741 5.89473 14.9408 9.04806 14.3274C11.1281 13.9208 12.8014 12.2474 13.2081 10.1674C13.8681 6.74743 11.2681 3.76076 7.97473 3.76076Z" />
    </svg>
  );
};
